import { ChangeEventHandler, useEffect, useState } from 'react';

import classNames from 'classnames';
import { DotBricksLoading } from 'src/common/components';
import Input from 'src/common/components/Input';
import { AccountProps } from 'src/tcr/types';
import { fetchAccounts } from 'src/user-profile/api';

interface AccountsListProps {
  onChange?: (id: string) => void;
  defaultValue?: string | null;
}

export const AccountsList = ({
  onChange = () => {},
  defaultValue = null,
}: AccountsListProps): JSX.Element => {
  const [search, setSearch] = useState('');
  const [accounts, setAccounts] = useState<AccountProps[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const retrieve = async (): Promise<any> => {
      try {
        setLoading(true);
        const result = await fetchAccounts(search, true);
        setAccounts(result.data.results as unknown as AccountProps[]);
      } catch (error) {
        setAccounts([]);
      } finally {
        setLoading(false);
      }
    };

    void retrieve();
  }, [search]);

  const handleSelectAccount: ChangeEventHandler<HTMLInputElement> = (event) => {
    onChange(event.target.id);
  };

  const handleSearch = (value: string): void => {
    setSearch(value);
  };

  return (
    <div className="flex flex-col">
      <Input placeholder="Search account" onDebounceChange={handleSearch} />
      <div className="min-h-24 relative">
        {loading && (
          <div className="absolute flex items-center justify-center w-full h-full bg-white-0.0 bg-opacity-50">
            <DotBricksLoading />
          </div>
        )}
        {!!accounts.length && (
          <ul className="h-80 mt-4 overflow-auto">
            {accounts.map((account, index) => {
              const className = index !== accounts.length - 1 ? 'border-b' : '';
              return (
                <li
                  key={account.id}
                  className={classNames(
                    'bg-white-0.0 flex justify-between border-white-2.0 px-2 py-2',
                    className
                  )}
                >
                  <input
                    type="radio"
                    name="accountRadio"
                    id={account.id}
                    onChange={handleSelectAccount}
                    defaultChecked={account.id === defaultValue}
                  />
                  <label
                    role="presentation"
                    className="flex flex-col flex-1 ml-4 truncate cursor-pointer"
                    htmlFor={account.id}
                  >
                    <div>{account.name}</div>
                    <div className="text-xs text-gray-2.0">{account.id}</div>
                  </label>
                </li>
              );
            })}
          </ul>
        )}
      </div>
    </div>
  );
};
